import PropTypes from 'prop-types';
import React from 'react';

let SelectChallenge = ({ challenges, updateChallenge }) => {
    if (!challenges || challenges.length <= 1) {
        return null;
    }

    return (
        <div className="save-search-to-challenge-list">
            {
                challenges.map((challenge) =>
                    <button key={challenge.id} className="link-button" onClick={() => updateChallenge(challenge.id)} >
                        {decodeURIComponent(challenge.title)}
                    </button>,
                )
            }
        </div>
    );
};
SelectChallenge.propTypes = {
    challenges: PropTypes.array.isRequired,
    updateChallenge: PropTypes.func.isRequired,
};
SelectChallenge = React.memo(SelectChallenge);
export default SelectChallenge;
